import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pm",
  "use": "icon-pm-usage",
  "viewBox": "0 0 220 220",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 220 220\" id=\"icon-pm\"><path d=\"M101.61,186.31H29.35V33.69H87.11a14.52,14.52,0,0,1,14.5,14.5Zm-63.26-9H92.61V48.19a5.51,5.51,0,0,0-5.5-5.5H38.35Z\" /><rect x=\"60.98\" y=\"62.98\" width=\"9\" height=\"39.89\" /><path d=\"M190.65,186.31H118.39V33.69h57.76a14.52,14.52,0,0,1,14.5,14.5Zm-63.26-9h54.26V48.19a5.5,5.5,0,0,0-5.5-5.5H127.39Z\" /><rect x=\"150.02\" y=\"62.98\" width=\"9\" height=\"39.89\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol